import ProgressBar from '@ramonak/react-progress-bar';

export const Progress = ({ completed }) => {
  return (
    <div className="py-20">
      <ProgressBar completed={completed} bgColor="#5867dd" height="10px" isLabelVisible={false} />
    </div>
  );
};
